import { Link } from "@tanstack/react-router";
import type { FC } from "react";
import { ROUTES } from "@/constants/routes";
import styles from "@/components/BackToLoginLink.module.css";

interface BackToLoginLinkProps {
  label: string;
}

const BackToLoginLink: FC<BackToLoginLinkProps> = ({ label }) => (
  <Link className={styles.backLink} to={ROUTES.LOGIN}>
    <i aria-hidden="true" className="pi pi-chevron-left" />
    {label}
  </Link>
);

export default BackToLoginLink;
